import { render, staticRenderFns } from "./ExaminationFinding.vue?vue&type=template&id=1fa24430&scoped=true&"
import script from "./ExaminationFinding.vue?vue&type=script&lang=js&"
export * from "./ExaminationFinding.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationFinding.vue?vue&type=style&index=0&id=1fa24430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa24430",
  null
  
)

export default component.exports